import React from 'react';

import { List } from 'antd';
import { useTranslation } from 'react-i18next';

import { DateSince } from 'common-ui';
import { UserNotification } from 'core/lib';

import { NotificationCardCommentIcon, NotificationCardWrapper, NotificationTitle } from '../components';

type CommentMentionNotificationCardProps = {
  notification: UserNotification;
  onClick: (id: number) => void;
};

const CommentMentionNotificationCard = ({ notification, onClick }: CommentMentionNotificationCardProps) => {
  const { t } = useTranslation();
  return (
    <NotificationCardWrapper key={notification.id} notification={notification} onClick={onClick}>
      <List.Item.Meta
        avatar={<NotificationCardCommentIcon />}
        title={
          <NotificationTitle
            title={t(`notifications:${notification.type}.mention`)}
            objectName={notification.objectName}
          />
        }
        description={<DateSince date={notification.dateCreated} />}
      />
    </NotificationCardWrapper>
  );
};

export default CommentMentionNotificationCard;
